<core-ui-dialog-base
  title="{{ 'EULA.TITLE' | translate }}"
  [cancelButton]="false"
  [hideCloseIcon]="true"
  [hideFooter]="true"
  class="eula-dialog"
>
  <div class="read-eula-btn-container">
    <a
      mat-flat-button
      color="primary"
      class="read-eula-btn"
      [href]="eulaUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ 'EULA.OPEN_EULA_IN_NEW_TAB' | translate }}
    </a>
  </div>
  <mat-checkbox (change)="checkboxIsChecked = $event.checked">
    {{ 'EULA.CONFIRMATION_BOX_TEXT' | translate }}
  </mat-checkbox>
  <div class="accept-deny-buttons">
    <button mat-stroked-button color="primary" (click)="declineEula()">
      {{ 'EULA.DECLINE' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="acceptEula()" [disabled]="!checkboxIsChecked">
      <span>{{ 'EULA.ACCEPT' | translate }}</span>
    </button>
  </div>
</core-ui-dialog-base>


